import React from 'react'
import PropTypes from 'prop-types'
import Link from '../link'
import {Text, Button, useStyleConfig, Flex} from '@chakra-ui/react'

const TeaserLink = ({icon, title, description, href, to, onClick, ...props}) => {
    const styles = useStyleConfig('TeaserLink')

    const Content = () => {
        return (
            <>
                <Flex {...styles.heading}>
                    {icon && React.cloneElement(icon, styles.icon)}
                    <Text layerStyle="insideLink" {...styles.title}>
                        {title}
                    </Text>
                </Flex>
                {description && <Text {...styles.description}>{description}</Text>}
            </>
        )
    }

    return href || to ? (
        <Link variant="teaserLink" href={href} to={to} onClick={onClick} {...props}>
            <Content />
        </Link>
    ) : (
        <Button variant="teaserLink" onClick={onClick} {...props}>
            <Content />
        </Button>
    )
}

TeaserLink.propTypes = {
    icon: PropTypes.element,
    title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    href: PropTypes.string,
    to: PropTypes.string,
    onClick: PropTypes.func
}

export default TeaserLink
